import React, { useState } from 'react';
import { Button, Input, Card } from '@/components/ui';
import { Link } from 'react-router-dom';
import { supabase } from '@/core/database/supabase';
import { toast } from 'sonner';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSent, setIsSent] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    
    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/auth/reset-password`,
      });
      if (error) throw error;
      setIsSent(true);
      toast.success('Đã gửi email khôi phục mật khẩu');
    } catch (error: any) {
      toast.error('Lỗi: ' + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <Card className="max-w-md w-full p-8 space-y-6">
        <div className="text-center space-y-2">
          <div className="w-16 h-16 bg-os-primary/10 text-os-primary rounded-2xl flex items-center justify-center mx-auto mb-4">
            <i className="ri-key-line text-3xl" />
          </div>
          <h2 className="text-2xl font-bold text-slate-900">Quên mật khẩu?</h2>
          <p className="text-slate-500 text-sm">
            {isSent 
              ? 'Vui lòng kiểm tra email của bạn để nhận hướng dẫn khôi phục mật khẩu.'
              : 'Nhập email của bạn và chúng tôi sẽ gửi hướng dẫn khôi phục.'}
          </p>
        </div>

        {!isSent ? (
          <form onSubmit={handleSubmit} className="space-y-4">
            <Input
              label="Email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="name@company.com"
            />
            <Button type="submit" className="w-full" isLoading={isLoading}>
              Gửi yêu cầu khôi phục
            </Button>
          </form>
        ) : (
          <Button variant="outline" className="w-full" onClick={() => setIsSent(false)}>
            Gửi lại email khác
          </Button>
        )}

        <div className="text-center">
          <Link to="/auth/login" className="text-sm font-medium text-os-primary hover:underline flex items-center justify-center gap-1">
            <i className="ri-arrow-left-line" />
            Quay lại đăng nhập
          </Link>
        </div>
      </Card>
    </div>
  );
}
